import { usePersonalizationAuthSync } from '@skin-seoul/service';

/**
 * Bridge component that watches login state changes and triggers
 * personalization re-resolution for the shortcode context.
 *
 * Also detects WordPress logout via `ss_just_logged_out` cookie:
 * clears actorId/sessionId and re-resolves with a fresh anonymous identity.
 */
export function ShortcodePersonalizationAuthSync() {
  usePersonalizationAuthSync();

  return null;
}
